import React from "react";
import PropTypes from 'prop-types';
import { FormHelperText } from '@material-ui/core';
import I18n from "../base/i18n.js";

 /**
 * Uses for launch auto deletion timer for component, if some error has occurred 
 * @component
 * @category HOC
 * @param props
 * @param {boolean} [props.allowAutoDeleteOnError = false] - Allow or disallow auto deletion
 * @param {number} [props.autoDeleteTimeout = 5] - Duration of auto deletion timer (in seconds)
 * @param {func} props.onAutoDelete - Callback, fires on auto deletion timer is over
 */
const WithAutoDeletion = (Component) => {

  class WithAutoDeletion extends React.Component {

    constructor(props) {
      super(props);

      this.state = {

      }
    }
    
    launchCountdown = () => {
      const { allowAutoDeleteOnError, autoDeleteTimeout, onAutoDelete } = this.props;
      if(!allowAutoDeleteOnError) {
        return;
      }

      this.setState({
        timeLeft: autoDeleteTimeout
      })

      this.intervalToken = setInterval(() => {
        const { timeLeft = autoDeleteTimeout } = this.state;
        this.setState({
          timeLeft: timeLeft - 1
        });
      }, 1000)

      setTimeout(() => {
        clearInterval(this.intervalToken)
        this.setState({
          timeLeft: undefined
        });
        if(onAutoDelete) {
          onAutoDelete();
        }
      }, autoDeleteTimeout * 1000)
    }

    render() {
      const { timeLeft } = this.state;
      return (
        <React.Fragment>
          <Component { ...this.props } 
                     launchCountdown = { this.launchCountdown } />
          {
            timeLeft && 
            <FormHelperText error = { true } >
              { I18n.t("component.with_auto_deletion.left_to_delete", {count: timeLeft}) }
            </FormHelperText>
          }
        </React.Fragment>
      )
    }
  }

  WithAutoDeletion.propTypes = {
    allowAutoDeleteOnError: PropTypes.bool,
    autoDeleteTimeout: PropTypes.number,
    onAutoDelete: PropTypes.func
  };
  
  WithAutoDeletion.defaultProps = {
    allowAutoDeleteOnError: false,
    autoDeleteTimeout: 5,
  }
  

  return WithAutoDeletion;
};

export default WithAutoDeletion;